import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import {ENUMS} from 'js/common';

export default class GenderSelect extends Component {
    static propTypes = {
        handleChange: PropTypes.func.isRequired,
        value: PropTypes.string
    };

    static defaultProps = {
        autofill: true
    };

    generateOptionsFromCreatorGenderSelect = () => {
        const {CreatorSelectableGenders} = ENUMS;

        return R.map(label => ({label, value: CreatorSelectableGenders[label]}))(
            R.keys(CreatorSelectableGenders)
        );
    };

    render() {
        const {value, handleChange} = this.props;

        const options = this.generateOptionsFromCreatorGenderSelect();

        return (
            <Select
                name="creator-gender-select"
                searchable={false}
                value={value}
                options={options}
                onChange={handleChange}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./components/smart_question/defaults/gender_select.js